import React from "react";
import { useNavigate } from "react-router-dom";
import { FiDownload, FiArrowLeft } from "react-icons/fi";

export default function Datasheet() {
  const navigate = useNavigate();

  const btn = {
    height: 40,
    padding: "0 16px",
    borderRadius: 8,
    border: "1px solid #CBD5E1",
    background: "#0EA5E9",
    color: "#fff",
    fontWeight: 700,
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    cursor: "pointer",
    fontSize: 14,
    whiteSpace: "nowrap", 
  };

  const headerBtn = {
    ...btn,
    background: "#F8FAFC",
    color: "#0F172A",
    border: "1px solid #E2E8F0",
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        width: "100vw",
        fontFamily:
          "Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, 'Helvetica Neue', Arial",
        backgroundColor: "#F1F5F9", 
        overflow: "hidden",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          padding: "12px 16px",
          borderBottom: "1px solid #E5E7EB",
          background: "#fff",
          zIndex: 50,
          boxShadow: "0 1px 2px 0 rgba(0, 0, 0, 0.05)",
        }}
      >
        <button onClick={() => navigate(-1)} style={headerBtn}>
          <FiArrowLeft size={18} /> <span className="hide-mobile">Back</span>
        </button>
        
        <h1 style={{ 
          margin: 0, 
          fontSize: "clamp(16px, 4vw, 20px)", 
          fontWeight: 800, 
          color: "#1E293B", 
          flex: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}>
          Smart Audit Datasheet
        </h1>

        <a href="/Smart-Audit-EN.pdf" download style={{ textDecoration: "none" }}>
          <span style={btn}>
            <FiDownload size={18} /> <span className="hide-mobile">Download PDF</span>
          </span>
        </a>
      </div>

      <div style={{ 
        flex: 1, 
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "auto", 
        WebkitOverflowScrolling: "touch", 
        display: "flex",
        justifyContent: "center",
        padding: "10px"
      }}>
        <object
          data="/Smart-Audit-EN.pdf#view=FitW" 
          type="application/pdf"
          width="100%"
          height="100%"
          style={{ 
            borderRadius: "4px",
            boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
            maxWidth: "1200px", 
          }}
        >
          <div
            style={{
              padding: 40,
              background: "#fff",
              border: "1px solid #E5E7EB",
              borderRadius: 8,
              textAlign: "center",
              margin: "auto",
              maxWidth: "500px"
            }}
          >
            <p style={{ color: "#64748B", marginBottom: 16 }}>
              This PDF cannot be displayed directly in this browser.
            </p>
            <a href="/Smart-Audit-EN.pdf" download style={{ ...btn, background: "#0F172A" }}>
              <FiDownload size={18} /> Click to download and open the file
            </a>
          </div>
        </object>
      </div>

      <style>{`
        @media (max-width: 480px) {
          .hide-mobile { display: none; }
        }
      `}</style>
    </div>
  );
}